// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"style_mainDiv__2tF3e"};